import React from 'react';
import moment from 'moment-timezone';
import { toDisplayDateTimeString } from "../../helpers/moment-ex";

export const DateRange = ({ as: Component = "span", className, start, end, alive, includeSeconds, children }) => {
    const currentYear = moment.utc().year();
    const withSeconds = (typeof includeSeconds === "undefined") ? false : includeSeconds;

    return (<Component className={`${className || ""}`}>
        {children}
        <span className="date-range-start">
            {toDisplayDateTimeString(start, (moment.utc(start).year() === currentYear), withSeconds)}
        </span>
        <i className="fa fa-long-arrow-right i-arrow" aria-hidden="true" />
        <span className="date-range-end">
            {typeof alive === "undefined" && alive ? "Now" :
                toDisplayDateTimeString(end, (moment.utc(end).year() === currentYear), withSeconds)}
        </span>
    </Component>);
};

export const DisplayDateRange = ({ as: Component = "label", className, start, end }) =>
    <Component className={`date-range-with-arrow ${className || ""}`}>
        <span className="date-range-start">
            {start}
        </span>
        <i className="fa fa-long-arrow-right i-arrow" aria-hidden="true" />
        <span className="date-range-end">
            {end}
        </span>
    </Component>;